module.exports = __webpack_public_path__ + "static/engineeringStory5-05eedb666ed7b87af4f94de055db6c96.jpg";